module.exports = __webpack_public_path__ + "img/309471405.8a80fee4.jpg";